import { useRouter } from 'next/router'
import InstructorBooking from '@/src/components/flchBooking/instructorContext/Booking'
import InstructorBookingContextProvider from '@/src/components/flchBooking/instructorContext/BookingContext'
import LocationBooking from '@/src/components/flchBooking/locationContext/Booking'
import LocationBookingContextProvider from '@/src/components/flchBooking/locationContext/BookingContext'
import Container from '@/src/components/layout/Container'

export default function Component() {
  const router = useRouter()

  return (
    <div className="grow bg-blue-50 pt-29 pb-12">
      <Container>
        {!router.query.instructorContext && (
          <LocationBookingContextProvider>
            <LocationBooking />
          </LocationBookingContextProvider>
        )}
        {router.query.instructorContext && (
          <InstructorBookingContextProvider>
            <InstructorBooking />
          </InstructorBookingContextProvider>
        )}
      </Container>
    </div>
  )
}
